export const sequence = {
    sequence_empty_list: 'لا توجد استبيانات متاحة لهذه الفترة الزمنية.',
    sequence_list_summary_zero: 'لا يوجد استبيان للإكمال',
    sequence_list_summary_one: 'استبيان واحد للإكمال',
    sequence_list_summary_two: 'استبيانان للإكمال',
    sequence_list_summary_few: '{{count}} استبيانات للإكمال',
    sequence_list_summary_many: '{{count}} استبيانًا للإكمال',
    sequence_list_summary_other: '{{count}} استبيان للإكمال',
    sequence_empty_title: 'كل شيء محدّث',
    sequence_empty_text: 'لا يوجد استبيان لإكماله في الوقت الحالي.',
    sequence_next_label: 'التالي:',
};
